
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";

const PfarrerPage = () => {
  const navigate = useNavigate();
  
  const handleNavigateBack = () => {
    navigate(-1);
    setTimeout(() => {
      const section = document.getElementById('ns3');
      if (section) {
        const offset = -80;
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset + offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }, 100);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBack = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById('career-journey');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const { data: images } = useQuery({
    queryKey: ["images", "pfarrer"],
    queryFn: async () => {
      console.log("Fetching images for pfarrer section");
      const { data, error } = await supabase
        .from("images")
        .select("*")
        .eq("section", "pfarrer")
        .order('created_at', { ascending: true });
      
      if (error) throw error;
      console.log("Retrieved images:", data);
      return data;
    },
  });

  const getImageUrl = (index: number) => {
    if (images && images[index]) {
      const { data } = supabase.storage
        .from('images')
        .getPublicUrl(images[index].storage_path);
      return data.publicUrl;
    }
    return 'https://images.unsplash.com/photo-1543363136-3fdb62e11be5?auto=format&fit=crop&q=80';
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#243949] to-[#517fa4]">
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-8">
          <Button 
            variant="ghost" 
            className="text-white hover:bg-white/10 p-2 h-auto group"
            onClick={handleNavigateBack}
          >
            <div className="flex items-center animate-horizontal-bounce">
              <ChevronLeft className="w-4 h-4" />
              <ChevronLeft className="w-4 h-4 -ml-2" />
            </div>
          </Button>
          
          <h2 className="text-lg md:text-xl font-bold text-white text-center uppercase flex-grow">
            VOM PFARRER ZUM UNTERNEHMENSBERATER
          </h2>
          
          <div className="w-[40px]"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
            <div className="aspect-[4/3]">
              <img
                src={getImageUrl(0)}
                alt="Pfarrer Bild 1"
                className="rounded-lg object-cover w-full h-full border border-[#9F9EA1] object-[center_30%]"
              />
            </div>
            <div className="aspect-[4/3]">
              <img
                src={getImageUrl(1)}
                alt="Pfarrer Bild 2"
                className="rounded-lg object-cover w-full h-full border border-[#9F9EA1] object-[center_35%]"
              />
            </div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg text-white space-y-4 mb-8">
            <p className="text-base md:text-lg text-white/90 text-left">
              Ich war evangelischer Pfarrer und habe diesen Beruf mit großer Leidenschaft ausgeübt. 
              Ich durfte Menschen in ihren größten Freuden und tiefsten Krisen begleiten. 
              Doch vor etwa sieben Jahren merkte ich, dass ich nicht mehr mit voller Leidenschaft 
              hinter diesem Beruf stehe.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
            <div className="aspect-[4/3]">
              <img
                src={getImageUrl(2)}
                alt="Pfarrer Bild 3"
                className="rounded-lg object-cover w-full h-full border border-[#9F9EA1]"
              />
            </div>
            <div className="aspect-[4/3]">
              <img
                src={getImageUrl(3)}
                alt="Pfarrer Bild 4"
                className="rounded-lg object-cover w-full h-full border border-[#9F9EA1] object-[center_10%]"
              />
            </div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg text-white space-y-4">
            <p className="text-base md:text-lg text-white/90 text-left">
              Also entschied ich mich 2017, meiner zweiten Leidenschaft – neben der Arbeit mit Menschen – zu folgen: 
              Zahlen und analytischem Denken. Ich wurde Unternehmensberater. Dieser Beruf bereitet mir unglaublich 
              viel Freude.
            </p>
            <p className="text-base md:text-lg text-white/90 text-left">
              Nebenberuflich verbinde ich jedoch beide Welten und begleite seit mehreren Jahren Menschen dabei, 
              ihre berufliche Orientierung (wieder) zu finden.
            </p>
          </div>

          <div className="flex justify-center mt-8">
            <Button 
              variant="ghost" 
              className="text-white hover:bg-white/10 p-2 h-auto group"
              onClick={handleBack}
            >
              <div className="flex items-center animate-horizontal-bounce">
                <ChevronLeft className="w-4 h-4" />
                <ChevronLeft className="w-4 h-4 -ml-2" />
              </div>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PfarrerPage;
